<template>
    <div class="contacto">
        <div class="ancla" id="contacto"></div>
        <div class="content">
            <b-row>
                <b-col cols="12" lg="10" offset-lg="1">
                    <b-row>
                        <b-col cols="12" md="5">
                            <h3>¡Hablemos!</h3>
                            <p class="texto">Siéntete libre de preguntar o sólo dejar un comentario</p>
                            <p class="correo"><img src="../assets/img/icn_mail.svg" alt="Correo"> hanniel@hannielmaldonado.com</p>
                            <a href="./static/Política_de_Privacidad.pdf" target="_blank"><small>Aviso de privacidad</small></a>
                            <small>Copyright © 2020 HannielMaldonado</small>
                        </b-col>
                       <b-col cols="12" md="7">
                            <b-form @submit="onSubmit">
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <b-form-group id="input-nombre" label="Nombre y apellido" label-for="nombre">
                                            <b-form-input
                                            id="nombre"
                                            v-model="nombre"
                                            type="text"
                                            required
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-group id="input-correo" label="Correo electrónico" label-for="correo">
                                            <b-form-input
                                            id="correo"
                                            v-model="correo"
                                            type="email"
                                            required
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group id="input-mensaje" label="Mensaje" label-for="mensaje">
                                            <b-form-textarea
                                                id="mensaje"
                                                v-model="mensaje"
                                                rows="3"
                                            ></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-button type="submit" variant="primary">Enviar mensaje</b-button>
                            </b-form>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>

        <b-modal ref="exito" centered hide-footer>
            <h3>¡Gracias!</h3>
            <p class="my-4">Su mensaje ha sido enviado.</p>
        </b-modal>
        <b-modal ref="error" centered hide-footer>
            <h3>Lo sentimos</h3>
            <p class="my-4">Hubo un error al enviar su mensaje, <br>intente de nuevo más tarde.</p>
        </b-modal>
        <b-modal ref="cargando" centered hide-footer>
            <h3>Cargando...</h3>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        data() {
            return {
                nombre: '',
                correo: '',
                mensaje: ''
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault()
                this.$refs['cargando'].show();
                const formData = new FormData();
                formData.append('nombre', this.nombre);
                formData.append('correo', this.correo);
                formData.append('mensaje', this.mensaje);
                axios.post('/static/sendMail.php', formData)
                .then((response)=> {
                    console.log(response)
                    this.$refs['cargando'].hide();
                    if(response.data == 1){
                        this.$refs['exito'].show();
                        setTimeout(()=>{ this.$refs['exito'].hide() }, 3000)
                        this.onReset()
                    }
                    else{
                        this.$refs['error'].show();
                        setTimeout(()=>{ this.$refs['error'].hide(); }, 3000)
                    }   
                })
                .catch((error)=> {
                    this.$refs['cargando'].hide();
                    console.log(error)
                    this.$refs['error'].show();
                    setTimeout(()=>{ this.$refs['error'].hide(); }, 3000)
                })
            },
            onReset(evt) {
                this.nombre = ''
                this.correo = ''
                this.mensaje = ''
            }
        }
    }
</script>

<style scoped>
    .contacto{
        padding: 100px 0;
        background-image: url('../assets/img/img_hm.svg');
        background-size: 25%;
        background-position: right bottom;
        background-repeat: no-repeat;
        background-color: #EC4802;
        position: relative;
    }
    .contacto *{
        color: white;
    }
    h3, h3 span{
        text-transform: none;
    }
    p.texto{
        max-width: 200px;
        margin: 0;
    }
    p.correo{
        margin: 30px 0;
    }
    p img{
        margin-top: -3px;
        margin-right: 5px;
    }
    small{
        display: block;
        opacity: 30%;
    }
    a{
        text-decoration: none!important;
    }
    .form-group{
        margin-bottom: 30px;
    }

    .form-control{
        background-color: transparent!important;
        border-radius: inherit!important;
        color: white!important;
        height: auto!important;
        padding: 5px 10px!important;
        box-shadow: none!important;
        outline: none!important;
        border-color: white!important;
    }
    
    .btn{
        background-color: white!important;
        color: #EC4802!important;
        border-radius: inherit!important;
        width: auto;
        padding: 5px 15px 10px 15px;
        text-transform: none;
        font-size: 11pt;
    }

    .btn::after{
        content: url('../assets/img/icn_send.svg');
        display: inline-block;
        margin-top: 5px;
        margin-left: 30px;
    }
    textarea{
        resize: none;
    }

    @media screen and (max-width: 767px){
        .contacto{
            padding: 80px 0;
        }
        form{
            margin-top: 40px;
        }
    }
</style>

<style>
    .contacto label::before{
        content: "\2217";
        position: absolute;
        top: -4px;
        left: 4px;
        color: white;
    }
    .contacto label{
        color: white;
    }
    .modal-content{
        border-radius: inherit;
        border: none!important;
        -webkit-box-shadow: 2px 0px 30px 0px rgba(0,0,0,1);
        -moz-box-shadow: 2px 0px 30px 0px rgba(0,0,0,1);
        box-shadow: 2px 0px 30px 0px rgba(0,0,0,1);
    }
    .modal-header{
        border-bottom: none!important;
        position: relative;
        box-shadow: none!important;
    }
    .modal-header .close{
        outline: none!important;
    }
    .modal-body{
        padding: 0 20px 61.6px 20px;
    }
    .modal-body h3{
        color: #EC4802;
        text-align: center;
    }
    .modal-body p{
        color: #171717;
        text-align: center;
        font-size: 12pt;
    }
    .modal-backdrop{
        background-color: rgba(255,255,255,0.9)!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Contacto.vue